import { mapActions, mapState } from 'vuex' 
import Vue from 'vue'

export default {
  data() {
    return {

    }
  },
  components: { 
    
  },
  computed: {
    ...mapState([
      'user'
    ])
  },
  methods: 
  {
    ga()
    {
      // this.$ga.page({
      //   page: window.location.pathname,
      //   title: document.title,
      //   location: window.location.href
      // })
    }
  },
  mounted () {
    this.ga()
  }
}
